import { z } from "zod";

/**
 * Weather and alerts used to be kept in this browser only. Those who set them
 * keep their choice: the first time the calendar asks for the account's
 * preferences and finds none saved, it carries this value over once, then drops
 * it. Browser only (it reads `localStorage`). Keep for one release, then delete.
 */
const STORAGE_KEY = "dashy_chantier_view";

const legacySchema = z.object({ weather: z.boolean(), alerts: z.boolean() });

export type LegacyPreferences = z.infer<typeof legacySchema>;

export function readLegacyPreferences(): LegacyPreferences | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored === null) return null;
    const parsed = legacySchema.safeParse(JSON.parse(stored));

    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function clearLegacyPreferences(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage refused: nothing to drop.
  }
}
